export default {
  main: [
    {
      name: 'no-auth',
      path: '/no-auth',
      component: () => import('@/components/not-auth.vue'),
      meta: {
        title: '抱歉，您没有权限',
        loginCheck: false,
        noTranslation: true,
        layout: 'main',
        noTabFrame: true
      }
    },
    {
      path: '*',
      name: 'all',
      component: () => import('@/components/not-find.vue'),
      meta: {
        title: '抱歉，您访问的页面不存在，请重新加载！',
        loginCheck: false,
        noTranslation: true,
        layout: 'main',
        noTabFrame: true
      }
    }
  ],
  fluid: []
}
